import {h, Fragment} from "preact"
import { useAppState, AutocompleteElement, Keywords } from "@nosto/preact"
import { productImagePlaceholder, addToCart, closeSearchOverlay } from "../helpers"
import { formatCurrency } from "../currencies"
import { popularSearches } from "../config"

export default function () {
    const { response: { products, keywords }, } = useAppState();

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    const handleKeywordClick = (event) => {
        if(event.target.closest('.ns-autocomplete-element')) {
            closeSearchOverlay();
        }
    }

    const handleAutocompleteClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        addToCart(event);
    }

    return (
        <div
            class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
            style={`${(products?.hits?.length > 0 || keywords?.hits?.length > 0) && 'padding-bottom: 32px !important;'}`}
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-row ns-flex-wrap ns-flex-md-nowrap">
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Products
                            </div> */}
                            {products?.hits?.map(hit => {
                                return (
                                    <AutocompleteElement                                          
                                        className="ns-ac-product ns-autocomplete-element" 
                                        hit={hit}
                                    >
                                        <spark-product-card
                                            parent-id={hit.productId}
                                        >
                                            <div
                                                data-url={hit.url}
                                                class="ns-d-flex flex-col ns-clickable ns-p-2"
                                                data-nosto-element="product"
                                            >
                                                <a href={hit.url}>
                                                    <img
                                                        class="ns-w-100 ns-h-auto ns-object-contain"
                                                        srcset={`
                                                            ${hit.imageUrl.toString().replace('.jpg', '_120x.jpg').replace('.png', '_120x.png')} 120w,
                                                            ${hit.imageUrl.toString().replace('.jpg', '_360x.jpg').replace('.png', '_360x.png')} 360w,
                                                            ${hit.imageUrl.toString().replace('.jpg', '_480x.jpg').replace('.png', '_480x.png')} 480w,
                                                            ${hit.imageUrl.toString().replace('.jpg', '_560x.jpg').replace('.png', '_560x.png')} 560w`}
                                                        src={`${hit.imageUrl.toString().replace('.jpg', '_6400x.jpg').replace('.png', '_640x.png') ?? productImagePlaceholder}`}
                                                        alt={hit.name}
                                                        width="150"
                                                        height="150"
                                                    />
                                                </a>
                                                <div class="cta-wrapper desktop">
                                                    {hit.availability === 'OutOfStock'
                                                        ?   <button 
                                                                aria-label="Sold Out" 
                                                                name="add" 
                                                                type="button" 
                                                                class="cta-btn sold-out-btn flex justify-center items-center w-full h-full text-center"
                                                                disabled
                                                            >
                                                                Sold Out
                                                            </button>
                                                        :   <button 
                                                                aria-label="Add to Cart"
                                                                name="add" 
                                                                type="button" 
                                                                data-product={hit.productId}
                                                                data-variant={hit.skus[0]?.id}
                                                                onClick={handleAutocompleteClick}
                                                                class="cta-btn flex justify-center items-center w-full h-full text-center"
                                                            >
                                                                {hit.tags1?.includes('pre-order') ? 'Pre-Order' : 'Add to Cart'}
                                                            </button>
                                                    }
                                                </div>
                                                <div class="ns-pl-2">
                                                    <a href={hit.url}>
                                                        {hit.brand && (
                                                            <div class="ns-color-black ns-mt-2 ns-mb-1 ns-font-4">
                                                                {hit.brand}
                                                            </div>
                                                        )}
                                                        <div class="ns-mb-2 ns-font-4 ns-clipped ns-text-one-line">
                                                            {hit.name}
                                                        </div>
                                                        <div>
                                                            <span>
                                                                {formatCurrency(hit.price)}
                                                            </span>
                                                            {hit.listPrice && (hit.listPrice > hit.price) && (
                                                                <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2">
                                                                    {formatCurrency(hit.listPrice)}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="cta-wrapper mobile">
                                                    {hit.availability === 'OutOfStock'
                                                        ?   <button 
                                                                aria-label="Sold Out" 
                                                                name="add" 
                                                                type="button" 
                                                                class="cta-btn sold-out-btn flex justify-center items-center w-full h-full text-center"
                                                                disabled
                                                            >
                                                                Sold Out
                                                            </button>
                                                        :   <button 
                                                                aria-label="Add to Cart"
                                                                name="add" 
                                                                type="button" 
                                                                data-product={hit.productId}
                                                                data-variant={hit.skus[0]?.id}
                                                                onClick={handleAutocompleteClick}
                                                                class="cta-btn flex justify-center items-center w-full h-full text-center"
                                                            >
                                                                {hit.tags1?.includes('pre-order') ? 'Pre-Order' : 'Add to Cart'}
                                                            </button>
                                                    }
                                                </div>
                                            </div>
                                        </spark-product-card>
                                    </AutocompleteElement>
                                )
                            })}
                        </div>
                    )}
                    
                    <div
                        class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ${
                            products?.hits?.length > 0
                                ? "ns-col-sm-3"
                                : "ns-col-sm-12"
                        }`}
                    >
                        {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                            Keywords
                        </div> */}
                        {keywords?.hits?.length > 0 && (
                            <div class="ns-d-flex ns-flex-column" onClick={handleKeywordClick}>
                                <h3 class="ns-keyword-heading">Suggested</h3>
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                        )}
                        <div class="ns-d-flex ns-flex-column">
                            <h3 class="ns-keyword-heading">Collections</h3>
                            {popularSearches.map(search => (
                                search.url ? (
                                    <a 
                                        key={search.text}
                                        class="ns-autocomplete-element ns-d-flex flex-row ns-justify-content-between ns-clickable ns-py-2 ns-px-4 ns-font-4" 
                                        href={search.url}
                                        onClick={() => location.href = search.url} /* some event listener is blocking regular navigation */
                                    >
                                        {search.text}
                                    </a>
                                ) : (
                                    <AutocompleteElement 
                                        key={search.text} 
                                        class="ns-autocomplete-element ns-clickable ns-py-2 ns-px-4 ns-font-4" 
                                        query={{ query: search.text }}
                                    >
                                        {search.text}
                                    </AutocompleteElement>
                                )
                            ))}
                        </div>
                    </div>
                    
                </div>
                {(products?.hits?.length > 0 || keywords?.hits?.length > 0) && 
                    <SubmitButton />
                }
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword,
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement
            hit={hit}
            filter={filter}
            class="ns-clickable ns-py-2 ns-px-4 ns-font-4"
        >
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({
    category,
    children,
}) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}

function SubmitButton() {
    // type="submit" not working

    const handleQuerySubmit = (event) => {
        event.preventDefault();
        const searchInputEl = event.target.closest('.nosto-autocomplete-wrapper')?.querySelector('input[type="search"]');
        if(!searchInputEl) return;
        searchInputEl.focus();
        const enterKeyEvent = new KeyboardEvent('keydown', {
            key: 'Enter',
            keyCode: 13,
            bubbles: true,
            cancelable: true,
        });
        searchInputEl.dispatchEvent(enterKeyEvent);
        document.querySelector('.search__button--close')?.click();
    }

    return (
        <div class="ns-autocomplete-submit ns-d-flex ns-justify-content-center">
            <button
                type="button"
                onClick={handleQuerySubmit}
                class="ns-act-btn ns-text-align-center ns-w-100"
            >
                See all search results
            </button>
        </div>
    )
}
